import { Component, HostBinding, inject, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CloseOverlayKeyboardDirective } from '../../directives/close-overlay.directives';
import { TranslateModule } from '@ngx-translate/core';
import { SessionReviewIdComponent } from '../session-review-id/session-review-id.component';
import { SessionReviewAttendanceComponent } from '../session-review-attendance/session-review-attendance.component';
import { SessionsService } from '@services/sessions.service';
import { tap } from 'rxjs';
import { EncryptorNameEnum, Session, SessionStatusEnum } from 'src/app/queries/generated';

@Component({
  selector: 'lv-session-review',
  templateUrl: 'session-review.component.html',
  styleUrls: ['session-review.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    CloseOverlayKeyboardDirective,
    TranslateModule,
    SessionReviewIdComponent,
    SessionReviewAttendanceComponent
  ]
})
export class SessionReviewComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly sessionsService = inject(SessionsService);

  _status = 'is-success';

  sessions$ = this.sessionsService
    .fromEncryptedToken(this.route.snapshot.params.token, EncryptorNameEnum.Review)
    .pipe(tap((sessions: Session[]) => this.setStatusFromSessions(sessions)));

  @HostBinding('class')
  get status(): string {
    return this._status;
  }

  private setStatusFromSessions(sessions: Session[]) {
    const failedSessions = sessions.filter((session) => session.status === SessionStatusEnum.Failed);
    if (failedSessions.length) {
      this._status = 'is-failed';
      return;
    }

    const pendingSessions = sessions.filter((session) => session.status === SessionStatusEnum.Pending);
    if (pendingSessions.length) {
      this._status = 'is-pending';
      return;
    }

    this._status = 'is-success';
  }
}
